/*
  Respuesta de un endpoint que devuelve PDF (pedido con responseType "blob").
  Si el servidor contestó un error, llega como JSON dentro del blob: se lee para mostrar
  su mensaje en vez de intentar abrir un PDF roto.
*/
export const blobToPdf = async (blob) => {
  if (!(blob instanceof Blob)) {
    return { message: blob?.message || "No se pudo generar el PDF." };
  }

  if (blob.type !== "application/pdf") {
    try {
      const json = JSON.parse(await blob.text());
      return { message: json?.message || "No se pudo generar el PDF." };
    } catch (e) {
      return { message: "No se pudo generar el PDF." };
    }
  }

  const url = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

  return { url };
};

export const PDF_BLOB_CONFIG = {
  headers: { Accept: "application/pdf" },
  responseType: "blob",
};
